import React from 'react';

interface Props {
  size?: number;
  className?: string;
  viewBox?: string;
  color?: string;
}

const REMOTE_ICON_SIGNAL_PATH =
  'M8 8H8.0053M6.50027 6.58605C6.89806 6.21112 7.43752 6.0005 8 6.0005C8.56248 6.0005 9.10194 ' +
  '6.21112 9.49974 6.58605M5 5.1716C5.39396 4.80016 5.86166 4.50551 6.3764 4.30449C6.89115 ' +
  '4.10347 7.44284 4 8 4C8.55716 4 9.10886 4.10347 9.6236 4.30449C10.1383 4.50551 10.606 ' +
  '4.80016 11 5.1716';

const RemoteIcon: React.FC<Props> = ({ size = 16, className, viewBox = '0 0 16 16', color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 10.75H15.25V13C15.25 13.6904 14.6904 14.25 14 14.25H2C1.30964 14.25 0.75 13.6904 0.75 13V10.75Z"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 11V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V11"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <path d={REMOTE_ICON_SIGNAL_PATH} stroke={color} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
};

export default RemoteIcon;
